import { memo } from 'react';
import { components, ValueContainerProps } from 'react-select';
import { Flex } from '@chakra-ui/react';

import { ControlledSelectOption } from '../types/ControlledSelectOption';

const ValueContainerComponent = <IsMulti extends boolean = false>({
  children,
  ...props
}: ValueContainerProps<ControlledSelectOption, IsMulti>) => (
  <components.ValueContainer {...props}>
    <Flex gap={1} wrap="wrap">
      {children}
    </Flex>
  </components.ValueContainer>
);

export const ValueContainer = memo(
  ValueContainerComponent,
) as typeof ValueContainerComponent;
